import Ad from "./Ad.vue"

export default Ad